import { streamingModeMap } from "./constants";

/**
 * The viewer settings a FRESH account gets — the exact object `/accounts/get` reflects before a user
 * has ever opened the Settings modal.
 *
 * Lives in the shared package because TWO runtimes need the same values: the server seeds new
 * accounts with it (userSettings module), and the web seeds the CP-283 share viewer with it — a
 * recipient has no account to read settings from, but `applySettings` dereferences several of these
 * into HOOPS setters that CRASH on undefined (selection/measurement/sheet colors), so the seed must
 * be complete, not `{}`.
 */
export const _defaultUserSettings = () => {
  return {
    General_framerate: 13,
    General_transparency: 0.4,
    General_enableFaceLineSel: true,
    General_hiddenLineOpacity: 0.2,
    General_projectionMode: "Orthographic",
    General_showBackfaces: true,
    General_showingCappingGeometry: true,
    General_orbitAroundSelectedObject: false,
    General_hoverTooltipFields: [] as string[],
    Effects_enableAmbientOcclusion: false,
    Effects_enableAntiAliasing: true,
    Effects_enableShadows: false,
    Effects_blurSamples: 5,
    Effects_enableBloom: false,
    Effects_intensityScale: 1,
    Effects_interactiveShadows: false,
    Effects_reflectionPlane: false,
    Effects_silhouette: false,
    Effects_threshold: 0.7,
    Lighting_enabled: false,
    Lighting_preset: "Default",
    Lighting_ambientIntensity: 0.15,
    Lighting_keyIntensity: 1,
    Lighting_fillIntensity: 0,
    Lighting_followCamera: true,
    Axis_showNavCube: false,
    Measurement_textPadding: 5,
    Measurement_textColor: "#000000",
    Measurement_textFontSize: 12,
    Measurement_textFontWeight: 0,
    Measurement_textBoxColor: "#ffffff",
    Measurement_textBoxOpacity: 1.0,
    Measurement_textBoxRadius: 0,
    Measurement_segmentTextVisiblity: true,
    Measurement_segmentTextBox: false,
    Measurement_segmentTextPadding: 5,
    Measurement_SegmentTextColor: "#000000",
    Measurement_segmentTextFontSize: 12,
    Measurement_segmentTextFontWeight: 0,
    Measurement_segmentTextBoxColor: "#ffffff",
    Measurement_segmentTextBoxOpacity: 1.0,
    Measurement_segmentTextBoxRadius: 0,
    Measurement_distanceMeasurementAxisLock: "None",
    Color_backgroundColor_2D: "#000000",
    Color_backgroundColor: "#9FE0FF",
    Color_backgroundColorBottom: "#ffffff",
    Color_cappingGeometryFace: "#808080",
    Color_cappingGeometryLine: "#808080",
    Color_enablePMIOverride: false,
    Color_enablePMIOverrideColor: "#000000",
    Color_selectionColorMeasurement: "#000000",
    Color_selectionColorBody: "#00cc00",
    Walk_enableCollisionDetection: false,
    Walk_enableMouseLook: false,
    Walk_mouseLookSpeed: 300,
    Walk_fieldOfView: 90,
    Walk_elevationSpeed: 4.2,
    Walk_rotation: 40,
    Walk_walkMode: "Mouse",
    Walk_walkSpeed: 3.2,
    Sheets_drawingColorBackground: "#ffffff",
    Sheets_drawingColorSheet: "#cae4f0",
    Sheets_drawingColorSheetShadow: "#7bd2fc",
    Sheets_showSheetBackground: false,
    Minimap_autoActivation: "Bim + Walk",
    Minimap_minimapColorAvatar: "#ff00ff",
    Minimap_minimapColorAvatarOutline: "#000000",
    Minimap_minimapColorBackground: "#ffffff",
    Minimap_minimapColorBorder: "#000000",
    Minimap_orientation: "North Up",
    Minimap_overlayBackgroundOpacity: 0.25,
    Minimap_overlayBorderOpacity: 1,
    Minimap_overlayFeetPerPixel: 0.1,
    Minimap_overlayZoomLevel: 1,
    Minimap_trackCamera: "",
    Minimap_active: false,
    ModelLoading_progressiveLoading: streamingModeMap.Interactive,
    ModelLoading_interactivityScale: 1,
    ModelLoading_boundingBoxPreview: false,
    ModelLoading_memoryLimit: false,
    ModelLoading_memoryLimitValue: 2,
  };
};
